import React, { useState, useEffect, useContext, useRef } from "react";
import "./home.css";
import Navbar from "../../components/navbar/Navbar";
import homeimg from "../../images/home.png";
import homemobileimg from "../../images/home-mobile.png";
import Form from "react-bootstrap/Form";

import Modal from "react-bootstrap/Modal";
import Rightside from "../../components/rightside/Rightside";
import Footer from "../../components/footer/Footer";
import { NavLink } from "react-router-dom";
import banner3 from "../../images/banner3.png";
import banner4 from "../../images/banner4.png";
// import Accordion from 'react-bootstrap/Accordion';
import logo from "../../images/white-logo.png";
import Accordion from "../../components/accordion/Accordion";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { CgSearch } from "react-icons/cg";
import { Link, useNavigate } from "react-router-dom";
import { GrFormClose } from "react-icons/gr";
import MobNav from "../../components/Mobnav/MobNav";
import axios from "axios";
import MyBackgroundImage from "../../images/image3.png";
import { Button } from "react-bootstrap";
import { GoPencil } from "react-icons/go";
import parse from "html-react-parser";
import SearchContext from "../../context/SearchContext";
import { FaSearchengin } from "react-icons/fa";
import FooterMob from "../../components/footer/FooterMob";
import Review from "../../components/review/Review";
import FeedBack from "../../components/popup/FeedBack";
import { baseLocal, baseUrl } from "../../context/BaseUrl";
import SideBarContext from "../../context/SideBarContext";

const Home = () => {
  const navigate = useNavigate("");
  const [showreview, setShowreview] = useState(false);

  const [result, setResult] = useState(false);
  const handlereview = () => setShowreview(!showreview);

  const { adBanners } = useContext(SideBarContext);

  const [feed, setFeed] = useState(false);

  const [Data, setData] = useState(false);
  // const [Institute, setInstitute] = useState('')
  // const [Location, setLocation] = useState('')

  // const { search, setSearch } = useContext(SearchContext);

  const [search, setSearch] = useState("");
  useEffect(() => {
    //fetch request js?

    if (search.length > 0) {
      setResult(false);
    }

    if (search && search.length > 0) {
      (async () => {
        try {
          const rawResponse = await fetch(
            `${baseLocal}/user/search/${search}`,
            {
              method: "get",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          );
          const content = await rawResponse.json();
          console.log(content);
          setResult(() => content);
        } catch (error) {
          setResult(false);
        }
      })();
    } else {
      setResult(false);
    }
  }, [search]);

  // const Print = () => {
  //   navigate(`/listing/${Institute}/${Location}`);
  // };

  const writeReviewToRef = useRef();

  async function fetchData() {
    try {
      const response = await axios.get(`${baseUrl}/user/home/homepage`);
      setData(response.data);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    Data && (
      <React.Fragment>
        <MobNav dnone="d-none" />
        <div className=" home-mobile home-heading d-block d-md-none">
        <div className="home-heading px-md-5 px-lg-0 ps-lg-5">
                  <h1>{Data.heading}</h1>

                  <div className="search mx-auto">
                    <input
                      type="text"
                      placeholder="search.."
                      onInput={(e) => setSearch(e.target.value)}
                    />
                    <span>
                      <Link to="">
                        <CgSearch />
                      </Link>
                    </span>
                    {result && (
                      <React.Fragment>
                        <div className="floatingSearch">
                          {result.institute.map((el) => {
                            return (
                              <div>
                                <NavLink
                                  variant="primary"
                                  className={"link"}
                                  to={`/institute/${el.institute_id}`}
                                  style={({ isActive }) => ({
                                    color: "#00f",
                                    padding: "5px 10px",
                                  })}
                                >
                                  {el.name}
                                </NavLink>
                              </div>
                            );
                          })}
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                  <div className="home-img d-flex mt-3">
                  <img className="homeimg img-fluid mx-auto" src={homemobileimg} alt={homemobileimg} />
                </div>
                </div>
        </div>
        <div className="home-background">
          <Navbar logoimg={logo} home={"homepage"} />
          <div className="container-fluid">
            <div className="row flex-column-reverse flex-lg-row">
              <div className="col-lg-8 col-md-9 col-sm-12 col-xs-12 ps-0 ps-lg-5">
                <div className="home-heading px-md-5 px-lg-0 ps-lg-5">
                  <h1>{Data.heading}</h1>

                  <div className="search mb-5">
                    <input
                      type="text"
                      placeholder="search.."
                      onInput={(e) => setSearch(e.target.value)}
                    />
                    <span>
                      <Link to="">
                        <CgSearch />
                      </Link>
                    </span>
                    {result && (
                      <React.Fragment>
                        <div className="floatingSearch">
                          {result.institute.map((el) => {
                            return (
                              <div>
                                <NavLink
                                  variant="primary"
                                  className={"link"}
                                  to={`/institute/${el.institute_id}`}
                                  style={({ isActive }) => ({
                                    color: "#00f",
                                    padding: "5px 10px",
                                  })}
                                >
                                  {el.name}
                                </NavLink>
                              </div>
                            );
                          })}
                          {/*result.course_list.map((el) => {
                            return (
                              <div>
                                <NavLink
                                  variant="primary"
                                  className={"link"}
                                  to={`/course/${el._id}`}
                                  style={({ isActive }) => ({
                                    color: "#00f",
                                    padding: "5px 10px",
                                  })}
                                >
                                  {el.course}
                                </NavLink>
                              </div>
                            );
                          })*/}
                          {/*result.vacancy.map((el) => {
                            return (
                              <div>
                                <NavLink
                                  variant="primary"
                                  className={"link"}
                                  to={`/vacancy-detail/${el._id}`}
                                  style={({ isActive }) => ({
                                    color: "#00f",
                                    padding: "5px 10px",
                                  })}
                                >
                                  {el.name}
                                </NavLink>
                              </div>
                            );
                          })*/}
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <div className="home-img">
                  <div
                    className="review reviewbtn"
                    onClick={() => setFeed(true)}
                  >
                    <GoPencil />
                    Write a review
                  </div>
                  <FeedBack handle={{ feed, setFeed }} />
                  <div
                    className={`reviewbg ${
                      showreview == true ? "d-flex" : "d-none"
                    }`}
                  >
                    <div className="login-popup review-popup">
                      <div className="login-form ">
                        <div className="">
                          <Form>
                            <div>
                              <GrFormClose
                                className="closereview pointer"
                                onClick={handlereview}
                              />
                              <h4>Review</h4>
                            </div>

                            <Form.Group className="mb-4">
                              <Form.Control
                                type="text"
                                // onChange={(e) => setEmail(e.target.value)}
                                // value={Email}
                                id="number"
                                placeholder="Subject"
                                required
                              />
                            </Form.Group>
                            <Form.Group className="mb-3">
                              <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Message"
                              />
                            </Form.Group>
                            <Form.Group className="mb-3">
                              <Form.Control
                                type="file"
                                // onChange={(e) => setEmail(e.target.value)}
                                // value={Email}
                                id="number"
                                placeholder="Subject"
                              />
                            </Form.Group>
                            <button
                              type="button"
                              className="signbtn"
                              onClick={handlereview}
                            >
                              Submit{" "}
                            </button>
                          </Form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <img className="homeimg " src={homeimg} alt={homeimg} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="home2 container-fluid">
          <div className="row">
            <div className="col-lg-8 col-md-7 col-sm-12 col-xs-12">
              <div className="leftside">
                <h3>About Obe Labs</h3>
                <p>{parse(Data.about)}</p>
                <div className="video">
                  <iframe
                    width="100%"
                    height="350"
                    src={"https://www.youtube.com/embed/lbW40hFgq4Y"}
                    title="YouTube video player"
                  />
                </div>
                <h3>Our Purpose</h3>
                <p>{parse(Data.purpose)}</p>
                <div className="banner">
                  <a href={adBanners.page_banner.link}>
                    <img src={adBanners.page_banner.banner} alt="banner3" />
                  </a>
                </div>
                <h3>Our Aim</h3>
                <p>{parse(Data.aim)}</p>

                <Accordion />

                {/*  <div className="banner">
                  <img src={banner4} alt="banner4" />
                </div>
                  */}
                <div className="write-review" ref={writeReviewToRef}>
                  {/* <Review
                        reload={fetchData}
                        // userid={}
                      /> */}
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-5 col-sm-12 col-xs-12">
              <div className="rigthside">
                <Rightside />
              </div>
            </div>
          </div>
        </div>
        {/* right side end */}
        <Footer />
        <FooterMob />
      </React.Fragment>
    )
  );
};

export default Home;
